import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)


const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */'../views/Home.vue'),
        meta: {
            title: 'KCB BONDS',
        }
    },
    {
        path: '/verify/email/:code',
        name: 'verify-email',
        component: () => import(/* webpackChunkName: "VerifyEmail" */'../views/Auth/VerifyEmail.vue')
    },
    {
        path: '/company/verify/:code',
        name: 'verify-company',
        component: () => import(/* webpackChunkName: "verifyCompany" */'../views/Auth/verifyCompany.vue'),
    },
    {
        path: '/reset/password/:code',
        name: 'reset-password',
        component: () => import(/* webpackChunkName: "ResetPassword" */'../views/Auth/ResetPassword.vue')

    },
    {
        path: '/verify/personal',
        name: 'verify.personal',
        component: () => import(/* webpackChunkName: "VerifyPersonal" */'../views/Auth/VerifyPersonal.vue'),
    },
    {
        path: '/verify-director-sms/:code/:id',
        name: 'verify.director.sms',
        component: () => import(/* webpackChunkName: "VerifyDirectorSms" */'../views/Auth/VerifyDirectorSms'),
    },
    {
        path: '/verify/phone',
        name: 'verify.phone',
        component: () => import(/* webpackChunkName: "VerifyPhone" */'../views/Auth/VerifyPhone.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "Login" */'../views/Auth/Login.vue')
    },
    {
        path: "/otp/auth",
        name: "otp",
        component: () => import("../views/Auth/Otp.vue"),
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import(/* webpackChunkName: "ForgotPassword" */'../views/Auth/ForgotPassword.vue')
    },
    {
        path: '/set-password',
        name: 'set-password',
        component: () => import(/* webpackChunkName: "SetPassword" */'../views/Auth/SetPassword.vue')
    },
    {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "Register" */'../views/Auth/Register.vue')
    },
    {
        path: '/register/confirm',
        name: 'register.confirm',
        component: () => import(/* webpackChunkName: "EmailSent" */'../views/Auth/EmailSent.vue')
    },
    {
        path: '/quote',
        name: 'quote',
        component: () => import(/* webpackChunkName: "Quote" */'../views/Quote.vue')
    },
    {
        path: '/bid-bonds/validate',
        name: 'bidbonds.validate',
        component: () => import(/* webpackChunkName: "ValidateBidBond" */'../views/ValidateBidBond.vue'),
        meta: {
            title: 'KCB BONDS Validate Bid Bond',
        }
    },
    {
        path: '/dashboard',
        component: () => import(/* webpackChunkName: "Dashboard" */'../views/Dashboard.vue'),
        children: [
            {
                path: '',
                name: 'dashboard',
                component: () => import(/* webpackChunkName: "HomeDashboard" */'../views/Dashboard/Home.vue'),
            },
            {
                path: 'wallet',
                component: () => import(/* webpackChunkName: "Wallet" */'../views/Dashboard/Wallet.vue'),
                children: [
                    {
                        path: '',
                        name: 'wallet.topup',
                        component: () => import(/* webpackChunkName: "Topup" */'../views/Dashboard/Wallet/Topup.vue')
                    },
                    {
                        path: 'list',
                        name: 'wallet.list',
                        component: () => import(/* webpackChunkName: "Wallets" */'../views/Dashboard/Wallet/Wallets.vue')
                    },
                    {
                        path: 'transactions',
                        name: 'wallet.transactions',
                        component: () => import(/* webpackChunkName: "Transactions" */'../views/Dashboard/Wallet/Transactions.vue')
                    },
                    {
                        path: 'agent/topup',
                        name: 'wallet.agent.topup',
                        component: () => import(/* webpackChunkName: "AgentTopup" */'../views/Dashboard/Wallet/AgentTopup.vue')
                    },
                    {
                        path: 'agent/transactions',
                        name: 'wallet.agent.transactions',
                        component: () => import(/* webpackChunkName: "AgentTransactions" */'../views/Dashboard/Wallet/AgentTransactions.vue')
                    }
                ]
            },
            {
                path: '/marketing',
                name: 'marketing',
                component: () => import(/* webpackChunkName: "Marketing" */'../views/Dashboard/Marketing.vue')
            },
            {
                path: 'profile',
                component: () => import(/* webpackChunkName: "Profile" */'../views/Dashboard/Profile.vue'),
                children: [
                    {
                        path: '',
                        name: 'profile.info',
                        component: () => import(/* webpackChunkName: "Info" */'../views/Dashboard/Profile/Info.vue')
                    },
                    {
                        path: 'security',
                        name: 'profile.security',
                        component: () => import(/* webpackChunkName: "Security" */'../views/Dashboard/Profile/Security.vue')
                    }
                ]
            },
            {
                path: 'companies',
                component: () => import(/* webpackChunkName: "Companies" */'../views/Dashboard/Companies.vue'),
                children: [
                    {
                        path: 'index',
                        name: 'companies.index',
                        component: () => import(/* webpackChunkName: "Companies Index" */'../views/Dashboard/Companies/Index.vue')
                    },
                    {
                        path: 'deleted',
                        name: 'companies.deleted',
                        component: () => import(/* webpackChunkName: "Companies Deleted" */'../views/Dashboard/Companies/Deleted.vue')
                    },
                    {
                        path: 'banned',
                        name: 'companies.banned',
                        component: () => import(/* webpackChunkName: "Companies Banned" */'../views/Dashboard/Companies/Banned.vue')
                    },
                    {
                        path: 'create',
                        name: 'companies.create',
                        component: () => import(/* webpackChunkName: "Companies Create" */'../views/Dashboard/Companies/Create.vue')
                    },
                    {
                        path: 'agents',
                        name: 'companies.agents',
                        component: () => import(/* webpackChunkName: "Companies Agents" */'../views/Dashboard/Companies/Agents.vue')
                    },
                    {
                        path: 'failed',
                        name: 'companies.failed',
                        component: () => import(/* webpackChunkName: "Companies Failed" */'../views/Dashboard/Companies/Failed.vue')
                    },
                    {
                        path: ':id',
                        name: 'companies.show',
                        component: () => import(/* webpackChunkName: "Companies Show" */'../views/Dashboard/Companies/Show.vue')
                    },
                    {
                        path: ':id/users',
                        name: 'companies.users',
                        component: () => import(/* webpackChunkName: "Companies Users" */'../views/Dashboard/Companies/Users.vue')
                    },
                    {
                        path: ':id/payment',
                        name: 'companies.payment',
                        component: () => import(/* webpackChunkName: "Companies Payment" */'../views/Dashboard/Companies/Payment.vue')
                    },
                    {
                        path: ':id/searching',
                        name: 'companies.searching',
                        component: () => import(/* webpackChunkName: "Companies Searching" */'../views/Dashboard/Companies/Searching.vue')
                    },
                    {
                        path: ':id/directors/create',
                        name: 'companies.directors.create',
                        component: () => import(/* webpackChunkName: "Directors Create" */'../views/Dashboard/Companies/Directors/Create.vue')
                    }
                ]
            },
            {
                path: 'bidbonds',
                component: () => import(/* webpackChunkName: "Bidbonds" */'../views/Dashboard/BidBonds/Navigation.vue'),
                children: [
                    {
                        path: 'create/:tender_no?/:company_id?',
                        name: 'bidbonds.create',
                        component: () => import(/* webpackChunkName: "Bidbonds Create" */'../views/Dashboard/BidBonds/Create.vue')
                    },
                    {
                        path: 'list',
                        name: 'bidbonds.index',
                        component: () => import(/* webpackChunkName: "Bidbonds Index" */'../views/Dashboard/BidBonds/Index.vue')
                    },
                    {
                        path: 'pricing/list',
                        name: 'bidbonds.pricing',
                        component: () => import(/* webpackChunkName: "BidbondPricing Index" */'../views/Dashboard/BidBonds/Pricing/Index.vue'),
                    },
                    // {
                    //     path: 'pricing/create',
                    //     name: 'bidbonds.pricing.create',
                    //     component: () => import(/* webpackChunkName: "BidbondPricing Create" */'../views/Dashboard/BidBonds/Pricing/Confirm.vue')
                    // },
                    {
                        path: 'pricing/group',
                        name: 'bidbonds.pricing.group',
                        component: () => import(/* webpackChunkName: "Pricing Groups" */'../views/Dashboard/BidBonds/Pricing/Groups.vue')
                    },
                    {
                        path: 'counterparties',
                        name: 'counterparties.index',
                        component: () => import(/* webpackChunkName: "CounterParties index" */'../views/Dashboard/CounterParties/Index.vue')
                    },
                    {
                        path: 'counterparties/create',
                        name: 'counterparties.create',
                        component: () => import(/* webpackChunkName: "CounterParties Create" */'../views/Dashboard/CounterParties/Create.vue')
                    },
                    {
                        path: ':id',
                        name: 'bidbonds.show',
                        component: () => import(/* webpackChunkName: "Bidbonds Show" */'../views/Dashboard/BidBonds/Show.vue')
                    },
                    {
                        path: ':id/edit',
                        name: 'bidbonds.edit',
                        component: () => import(/* webpackChunkName: "Bidbonds Edit" */'../views/Dashboard/BidBonds/Edit.vue')
                    },
                    {
                        path: ':id/:co/payment',
                        name: 'bidbonds.payment',
                        component: () => import(/* webpackChunkName: "Bidbonds Payment" */'../views/Dashboard/BidBonds/Payment.vue')
                    },
                    {
                        path: 'individualLimit',
                        name: 'bidbonds.individualLimit',
                        component: () => import(/* webpackChunkName: "Bidbonds Index" */'../views/Dashboard/BidBonds/individualLimit.vue')
                    },
                ]
            },
            {
                path:'pricing-tariff',
                name:'pricing-tariff',
                component:() => import(/* webpackChunkName: "Pricing Tariff" */'../views/Dashboard/BidBonds/PricingTariff/Navigation.vue'),
                children:[
                    {
                        path: 'index',
                        name: 'pricing-tariff.index',
                        component: () => import(/* webpackChunkName: "Pricing Tariff Index" */'../views/Dashboard/BidBonds/PricingTariff/Index.vue'),
                    },
                    {
                        path: 'create',
                        name: 'pricing-tariff.create',
                        component: () => import(/* webpackChunkName: "Pricing Tariff Create" */'../views/Dashboard/BidBonds/PricingTariff/Create.vue')
                    },
                    {
                        path: 'approvals',
                        name: 'pricing-tariff.approvals',
                        component: () => import(/* webpackChunkName: "Pricing Tariff Approval" */'../views/Dashboard/BidBonds/PricingTariff/Approvals.vue')
                    }
                ]
            },
            {
                path: 'performance',
                component: () => import(/* webpackChunkName: "Performance" */'../views/Dashboard/Performance.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'performance.index',
                        component: () => import(/* webpackChunkName: "Performance Index" */'../views/Dashboard/Performance/Index.vue')
                    },
                    {
                        path: 'matured',
                        name: 'performance.matured',
                        component: () => import(/* webpackChunkName: "Performance Matured" */'../views/Dashboard/Performance/Matured.vue')
                    },
                    {
                        path: 'create/:contract_no?/:company_id?',
                        name: 'performance.create',
                        component: () => import(/* webpackChunkName: "Performance Create" */'../views/Dashboard/Performance/Create.vue')
                    },
                    {
                        path: 'award_letter/:secret/:company_id',
                        name: 'performance.award',
                        component: () => import(/* webpackChunkName: "Award Letter" */'../views/Dashboard/Performance/Views/AwardLetter.vue')
                    },
                    {
                        path: 'pricing/list',
                        name: 'performance.pricing',
                        component: () => import(/* webpackChunkName: "Performance Pricing Index" */'../views/Dashboard/Performance/Pricing/Index.vue'),
                    },
                    {
                        path: 'pricing/create',
                        name: 'performance.pricing.create',
                        component: () => import(/* webpackChunkName: "Performance Pricing Create" */'../views/Dashboard/Performance/Pricing/Create.vue')
                    },
                    {
                        path: 'pricing/group',
                        name: 'performance.pricing.group',
                        component: () => import(/* webpackChunkName: "Performance Pricing Groups" */'../views/Dashboard/Performance/Pricing/Groups.vue')
                    },
                    {
                        path: 'templates',
                        name: 'performance.templates.index',
                        component: () => import(/* webpackChunkName: "Performance Templates index" */'../views/Dashboard/Performance/Templates/Index.vue')
                    },
                    {
                        path: 'templates/create',
                        name: 'performance.templates.create',
                        component: () => import(/* webpackChunkName: "Performance Templates Create" */'../views/Dashboard/Performance/Templates/Create.vue')
                    },
                    {
                        path: 'templates/:id',
                        name: 'performance.templates.show',
                        component: () => import(/* webpackChunkName: "Performance Templates Show" */'../views/Dashboard/Performance/Templates/Show.vue')
                    },
                    {
                        path: 'templates/:id/edit',
                        name: 'performance.templates.edit',
                        component: () => import(/* webpackChunkName: "Performance Templates Edit" */'../views/Dashboard/Performance/Templates/Edit.vue')
                    },
                    {
                        path: 'limits/:id',
                        name: 'performance.limits',
                        component: () => import(/* webpackChunkName: "Performance Limits" */'../views/Dashboard/Companies/Performance/Show.vue')
                    },
                    {
                        path: 'counterparties',
                        name: 'performance.counterparties.index',
                        component: () => import(/* webpackChunkName: "Performance Counterparties index" */'../views/Dashboard/Performance/Counterparties/Index.vue')
                    },
                    {
                        path: 'counterparties/create',
                        name: 'performance.counterparties.create',
                        component: () => import(/* webpackChunkName: "Performance Counterparties Create" */'../views/Dashboard/Performance/Counterparties/Create.vue')
                    },
                    {
                        path: ':secret',
                        name: 'performance.show',
                        component: () => import(/* webpackChunkName: "Performance Show" */'../views/Dashboard/Performance/Show.vue')
                    },
                    {
                        path: ':secret/edit',
                        name: 'performance.edit',
                        component: () => import(/* webpackChunkName: "Performance Edit" */'../views/Dashboard/Performance/Edit.vue')
                    },
                    {
                        path: ':secret/:company/payment',
                        name: 'performance.payment',
                        component: () => import(/* webpackChunkName: "Performance Payment" */'../views/Dashboard/Performance/Payment.vue')
                    }
                ]
            },
            {
                path: 'tenders',
                name: 'tenders',
                component: () => import(/* webpackChunkName: "Tenders" */'../views/Dashboard/Tenders.vue')
            },
            {
                path: 'quotes',
                component: () => import(/* webpackChunkName: "Quotes" */'../views/Dashboard/Quotes.vue'),
                children: [
                    {
                        path: 'index',
                        name: 'quotes.index',
                        component: () => import(/* webpackChunkName: "Quotes Index" */'../views/Dashboard/Quotes/Index.vue')
                    },
                    {
                        path: 'create',
                        name: 'quotes.create',
                        component: () => import(/* webpackChunkName: "Quotes Create" */'../views/Dashboard/Quotes/Create.vue')
                    }
                ]
            },
            {
                path: 'banlists',
                name: 'Banlists.index',
                component: () => import(/* webpackChunkName: "Banlists" */'../views/Dashboard/Banlists/Index.vue'),
            },
            {
                path: 'Banlists/create',
                name: 'Banlists.create',
                component: () => import(/* webpackChunkName: "Banlists Create" */'../views/Dashboard/Banlists/Create.vue'),
            },
            {
                path: 'payments',
                name: 'payments.index',
                component: () => import(/* webpackChunkName: "Payments Index" */'../views/Dashboard/Payments/Index.vue')
            },
            {
                path: 'payments/confirm',
                name: 'payments.confirm',
                component: () => import(/* webpackChunkName: "Payments Create" */'../views/Dashboard/Payments/Confirm.vue')
            },
            {
                path: 'users',
                component: () => import(/* webpackChunkName: "Users" */'../views/Dashboard/Users.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'users.index',
                        component: () => import(/* webpackChunkName: "Users Index" */'../views/Dashboard/Users/Index.vue')
                    },
                    {
                        path: 'deleted',
                        name: 'users.deleted',
                        component: () => import(/* webpackChunkName: "Users Deleted" */'../views/Dashboard/Users/Deleted.vue')
                    },
                    {
                        path: 'banned',
                        name: 'users.banned',
                        component: () => import(/* webpackChunkName: "Users Banned" */'../views/Dashboard/Users/Banned.vue')
                    },
                    {
                        path: 'roles',
                        name: 'users.roles',
                        component: () => import(/* webpackChunkName: "Users Roles" */'../views/Dashboard/Users/Roles.vue')
                    },
                    {
                        path: 'permissions',
                        name: 'users.permissions',
                        component: () => import(/* webpackChunkName: "Users permissions" */'../views/Dashboard/Users/Permissions.vue')
                    },
                    {
                        path: 'create',
                        name: 'users.create',
                        component: () => import(/* webpackChunkName: "Users create" */'../views/Dashboard/Users/Create.vue')
                    },
                    {
                        path: 'customers',
                        name: 'users.customers',
                        component: () => import(/* webpackChunkName: "Customers" */'../views/Dashboard/Users/Customers.vue')
                    },
                    {
                        path: 'relationship_managers',
                        name: 'rms',
                        component: () => import(/* webpackChunkName: "RMs" */'../views/Dashboard/RMs/Index.vue')
                    },
                    {
                        path: 'relationship_managers/create/:id?/:rm_id?/:br_id?',
                        name: 'rms.create',
                        component: () => import(/* webpackChunkName: "RMs Create" */'../views/Dashboard/RMs/Create.vue')
                    },
                    {
                        path: ':id',
                        name: 'users.show',
                        component: () => import(/* webpackChunkName: "Users show" */'../views/Dashboard/Users/Show.vue')
                    },
                    {
                        path: ':id/edit',
                        name: 'users.edit',
                        component: () => import(/* webpackChunkName: "Users edit" */'../views/Dashboard/Users/Edit.vue')
                    },
                ]
            },
            {
                path: 'reports',
                name: 'reports',
                component: () => import(/* webpackChunkName: "reports" */'../views/Dashboard/Reports.vue'),
                children: [
                    {
                        path: 'bidbonds',
                        name: 'reports.bidbonds',
                        component: () => import(/* webpackChunkName: "reports bidbonds" */'../views/Dashboard/Reports/BidBonds/Home.vue'),
                        children: [
                            {
                                path: 'index',
                                name: 'reports.bidbonds.index',
                                component: () => import(/* webpackChunkName: "reports bidbonds index" */'../views/Dashboard/Reports/BidBonds/Index.vue')
                            },
                            {
                                path: 'summary',
                                name: 'reports.bidbonds.summary',
                                component: () => import(/* webpackChunkName: "reports bidbonds summary" */'../views/Dashboard/Reports/BidBondSummary/Index.vue')
                            },
                            {
                                path: 'rm-summary',
                                name: 'reports.bidbonds.rm-summary',
                                component: () => import(/* webpackChunkName: "reports rm-summary" */'../views/Dashboard/Reports/BidBonds/RMSummary.vue')
                            },
                            {
                                path: 'expiry',
                                name: 'reports.bidbonds.expiry',
                                component: () => import(/* webpackChunkName: "reports bidbond-expiry'" */'../views/Dashboard/Reports/BidBondExpiry/Index.vue')
                            },
                            {
                                path: 'by-creator',
                                name: 'reports.bidbonds.by-creator',
                                component: () => import(/* webpackChunkName: "reports bids-by-creator" */'../views/Dashboard/Reports/BidBonds/BidsByCreator.vue')
                            },
                            {
                                path: 'rms',
                                name: 'reports.bidbonds.rms',
                                component: () => import(/* webpackChunkName: "reports rm" */'../views/Dashboard/Reports/BidBonds/RMBids.vue')
                            },
                            {
                                path: 'company/summary',
                                name: 'reports.bidbonds.company.summary',
                                component: () => import(/* webpackChunkName: "reports company-summary" */'../views/Dashboard/Reports/BidBonds/Summary.vue')
                            },
                        ]
                    },
                    {
                        path: 'companies',
                        name: 'reports.companies',
                        component: () => import(/* webpackChunkName: "reports companies" */'../views/Dashboard/Reports/Companies/Home.vue'),
                        children: [
                            {
                                path: 'rms',
                                name: 'reports.companies.rms',
                                component: () => import(/* webpackChunkName: "reports RMcompanies" */'../views/Dashboard/Reports/Companies/RMs.vue')
                            },
                            {
                                path: 'creator',
                                name: 'reports.companies.bycreator',
                                component: () => import(/* webpackChunkName: "reports companies creator" */'../views/Dashboard/Reports/Companies/ByCreator.vue')
                            },
                            {
                                path: 'commission',
                                name: 'reports.companies.commission',
                                component: () => import(/* webpackChunkName: "reports companies commission" */'../views/Dashboard/Reports/Companies/Commission.vue')
                            },
                        ]
                    },
                    {
                        path: 'payments',
                        name: 'reports.bidbonds.payments',
                        component: () => import(/* webpackChunkName: "reports bidbonds-payment" */'../views/Dashboard/Reports/Payments.vue')
                    },
                    {
                        path: 'tenders',
                        name: 'reports.tenders',
                        component: () => import(/* webpackChunkName: "Tender Leads Reports" */'../views/Dashboard/Reports/Tenders.vue')
                    },
                ]
            },
            {
                path: 'agents',
                component: () => import(/* webpackChunkName: "agents" */'../views/Dashboard/Agents.vue'),
                children: [
                    {
                        path: 'index',
                        name: 'agents.index',
                        component: () => import(/* webpackChunkName: "agents index" */'../views/Dashboard/Agents/Index.vue')
                    },
                    {
                        path: 'deleted',
                        name: 'agents.deleted',
                        component: () => import(/* webpackChunkName: "agents Deleted" */'../views/Dashboard/Agents/Deleted.vue')
                    },
                    {
                        path: 'create',
                        name: 'agents.create',
                        component: () => import(/* webpackChunkName: "agents Create" */'../views/Dashboard/Agents/Create.vue')
                    },
                    {
                        path: ':id',
                        name: 'agents.show',
                        component: () => import(/* webpackChunkName: "agents Show" */'../views/Dashboard/Agents/Show.vue')
                    },
                ],
            },
            {
                path: 'commission',
                name: 'commission.index',
                component: () => import(/* webpackChunkName: "Commission" */'../views/Dashboard/Commission/Index.vue')
            },
            {
                path: 'bid-bond-templates',
                component: () => import(/* webpackChunkName: "bid-bond-templates" */'../views/Dashboard/BidBonds/Navigation.vue'),
                children: [
                    {
                        path: '',
                        name: 'bid-bond-templates.index',
                        component: () => import(/* webpackChunkName: "bid-bond-templates index" */'../views/Dashboard/BidBondTemplates/Index.vue')
                    },
                    {
                        path: 'create',
                        name: 'bid-bond-templates.create',
                        component: () => import(/* webpackChunkName: "bid-bond-templates Create" */'../views/Dashboard/BidBondTemplates/Create.vue')
                    },
                    {
                        path: ':id',
                        name: 'bid-bond-templates.show',
                        component: () => import(/* webpackChunkName: "bid-bond-templates show" */'../views/Dashboard/BidBondTemplates/Show.vue')
                    },
                    {
                        path: ':id/edit',
                        name: 'bid-bond-templates.edit',
                        component: () => import(/* webpackChunkName: "bid-bond-templates edit" */'../views/Dashboard/BidBondTemplates/Edit.vue')
                    }
                ]
            },
            {
                path: 'pricing',
                name: 'pricing',
                component: () => import(/* webpackChunkName: "Pricing Navigation" */'../views/Dashboard/Pricing/Navigation.vue'),
                children: [
                    {
                        path: 'index',
                        name: 'pricing.index',
                        component: () => import(/* webpackChunkName: "Pricing List" */'../views/Dashboard/Pricing/Index.vue')
                    },
                    {
                        path: 'approvals',
                        name: 'pricing.approvals',
                        component: () => import(/* webpackChunkName: "Pricing Approvals" */'../views/Dashboard/Pricing/Approvals.vue')
                    },
                ]
            },
            {
                path: 'settings',
                name: 'settings',
                component: () => import(/* webpackChunkName: "Settings Navigation" */'../views/Dashboard/Settings/Navigation.vue'),
            },
            {
                path: 'bidbond-limit-settings',
                name: 'bidbond-limit-settings',
                component: () => import(/* webpackChunkName: "bid limit Navigation" */'../views/Dashboard/BidLimits/Navigation.vue'),
                children: [
                    {
                        path: 'edit',
                        name: 'bidbond-limit-settings.edit',
                        component: () => import(/* webpackChunkName: "bid limit settings edit" */'../views/Dashboard/BidLimits/Edit.vue'),
                    },
                    {
                        path: 'approvals',
                        name: 'bidbond-limit-settings.approvals',
                        component: () => import(/* webpackChunkName: "Bid Limit Approvals" */'../views/Dashboard/BidLimits/Approvals.vue')
                    },
                ]
            },
            {
                path: 'whats-new',
                name: 'whats-new',
                component: () => import(/* webpackChunkName: "WhatsNew" */'../views/Dashboard/WhatsNew.vue'),
            },
            {
                path: 'terms',
                name: 'terms',
                component: () => import(/* webpackChunkName: "Terms" */'../views/Dashboard/Terms.vue'),
            },
            {
                path: 'privacy',
                name: 'privacy',
                component: () => import(/* webpackChunkName: "Privacy" */'../views/Dashboard/Privacy.vue')
            },
        ]
    },
    {
        path: '*',
        name: '404',
        component: () => import(/* webpackChunkName: "404" */'../views/404.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router